"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helperFunctions = require("../../../styles/helperFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var ContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "LayoutFullPageContentWrapperstyles__ContentWrapper",
  componentId: "lm83vz-0"
})(["padding:", ";@media only screen and (max-width:", "){padding:", " 0;}"], function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 2, props.theme.standardPadding);
}, function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 2, props.theme.standardPadding);
});

exports.ContentWrapper = ContentWrapper;